<template>
  <div>
    <pulse-loader :style="style" v-if="loading" sm=12 class="text-center align-content-center align-items-center" color="#290A99"/>
    <b-container fluid v-else>
      <b-row style="background: #d0cfd4">
        <b-col sm="3">
          <b-card no-body class="border-0 mb-0">
            <div  class="p-1 card-header-1">
              Presencial VS Internet
              <i class="float-right fa fa-table fa-sm hover-1" style="margin-top: auto;" @click="goToComponentDetail(0)"></i>
            </div>
            <Chart :series="chart1.series"
                   :plotOptions="plotOptions"
                   :height="vuexAvailableHeight"></Chart>
          </b-card>

        </b-col>
        <b-col sm="3">
          <b-card no-body class="border-0 mb-0">
            <div  class="p-1 card-header-1">
              Promotor VS Sin Promotor
              <i class="float-right fa fa-table fa-sm hover-1" style="margin-top: auto;" @click="goToComponentDetail(1)"></i>
            </div>
            <Chart :series="chart2.series"
                   :plotOptions="plotOptions"
                   :height="vuexAvailableHeight"></Chart>
          </b-card>

        </b-col>
        <b-col sm="3">
          <b-card no-body class="border-0 mb-0">
            <div  class="p-1 card-header-1">
              Top Comunas
              <i class="float-right fa fa-table fa-sm hover-1" style="margin-top: auto;" @click="goToComponentDetail(2)"></i>
            </div>
            <Chart :series="chart3.series"
                   :plotOptions="plotOptions"
                   :height="vuexAvailableHeight"></Chart>
          </b-card>

        </b-col>
        <b-col sm="3">
          <b-card no-body class="border-0 mb-0">
            <div  class="p-1 card-header-1">
              Top 50 productos
              <i class="float-right fa fa-table fa-sm hover-1" style="margin-top: auto;" @click="goToComponentDetail(3)"></i>
            </div>
            <Chart :series="chart4.series"
                   :plotOptions="plotOptions"
                   :height="vuexAvailableHeight"></Chart>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  import { sales } from '../../../../../services/api/ExpertoRetail'
  import Chart from '@/expertoRetail/components/charts/Highcharts'
  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import { pie1, pie2, pie3, pie4, chartMetricOptions } from '@/expertoRetail/atoms/AccumulatedSales/Common/baseParameters'
  export default {
    name: 'PieDonutDataLoad',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [GeneralUtils, DimensionUtils],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: {
      selectedDim: {
        required: false,
        default: 'retail_name'
      }
    },
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {
      Chart
    },
    data () {
      return {
        style: '',
        loading: false,
        metricOptions: chartMetricOptions,
        builtParameters: [],
        params: [pie1, pie2, pie3, pie4],
        chart1: {
          series: [{
            type: 'pie',
            data: []
          }]
        },
        chart2: {
          series: [{
            type: 'pie',
            data: []
          }]
        },
        chart3: {
          series: [{
            type: 'pie',
            data: []
          }]
        },
        chart4: {
          series: [{
            type: 'pie',
            data: []
          }]
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            }
          }
        }
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
      this.builtParameters = []
      this.style = 'background-color: #FFFFFF; overflow: auto; height: ' + String(this.vuexAvailableHeight + 30) + 'px'
      this.loadData()
    },
    watch: {
      vuexMetric () {
        this.loadData()
      },
      vuexGlobalFilters () {
        this.loadData()
      },
      vuexFactTable () {
        this.loadData()
      },
      vuexAvailableHeight () {
        this.style = 'background-color: #FFFFFF; overflow: auto; height: ' + String(this.vuexAvailableHeight + 30) + 'px'
      }
    },
    computed: {
      vuexMetric () {
        return this.$store.state.metric
      },
      vuexGlobalFilters () {
        return this.$store.state.globalFilters
      },
      vuexFactTable () {
        return this.$store.state.accumulatedSales.factTable
      },
      vuexAvailableHeight () {
        return Math.round(this.$store.state.dashboardAvailableHeight / 3.2671)
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      buildParameters (componentParams) {
        let parameters = {parameters: {}}
        let dim = this.$_dimensionUtils_getDimensionParameterOnlyValue(componentParams.dimension)
        parameters.parameters['store_dimensions'] = dim.store_dimensions
        parameters.parameters['product_dimensions'] = dim.product_dimensions
        parameters.parameters['metrics'] = {normal: chartMetricOptions[this.vuexMetric]}
        parameters.parameters['fact'] = {type: 'table', name: this.vuexFactTable}
        parameters.parameters['sort'] = {field: chartMetricOptions[this.vuexMetric][0], dir: 'DESC'}
        parameters.parameters['limit'] = componentParams.limit
        parameters.parameters['offset'] = 0
        parameters.parameters['store_filters'] = {}
        parameters.parameters['product_filters'] = {}
        let filterCopy = this.$_generalUtils_deepJsonCopy(this.vuexGlobalFilters)
        parameters.parameters = {...parameters.parameters, ...filterCopy}
        parameters.parameters.store_filters['store_type_id'] = componentParams.store_type_id
        this.builtParameters.push(parameters)
        return parameters
      },
      chartCatDim () {
        if (this.selectedDim.store_dimensions.length > 0) {
          return this.selectedDim.store_dimensions[0]
        } else if (this.selectedDim.product_dimensions.length > 0) {
          return this.selectedDim.product_dimensions[0]
        }
      },
      dimTypeDecider (params) {
        return params.dimension
      },
      // ********************************************** VUEX COMMITS ***************************************************
      goToComponentDetail (index) {
        let dim = this.$_dimensionUtils_getDimensionParameterComplete(this.builtParameters[index])
        let specialFilters = this.builtParameters[index].parameters.store_filters.store_type_id
        this.$store.commit('commit_accumulatedSalesParameters', this.builtParameters[index])
        this.$store.commit('commit_accumulatedSalesView', 'GridDetail1')
        this.$store.commit('commit_gridMainDim', dim)
        this.$store.commit('commit_specialFilters', specialFilters)
      },
      // ********************************************** REQUESTS *******************************************************
      loadData () {
        this.loading = true
        const promises = [
          sales.salesTwoRanges(this.buildParameters(pie1)),
          sales.salesTwoRanges(this.buildParameters(pie2)),
          sales.salesTwoRanges(this.buildParameters(pie3)),
          sales.salesTwoRanges(this.buildParameters(pie4))
        ]
        Promise.all(promises)
          .then(response => {
            response.forEach((r, index) => {
              let dim = this.dimTypeDecider(this.params[index])
              let cat = r.data.map(x => x[dim])
              this['chart' + [index + 1]].series[0].data = []
              cat.forEach((i) => {
                this['chart' + [index + 1]].series[0].data.push(
                  { name: i,
                    y: r.data.filter(x => x[dim] === i)[0][chartMetricOptions[this.vuexMetric][0]]
                  }
                )
              })
            })
          })
          .catch(reason => {
            console.log(reason)
          })
          .finally(() => {
            this.chartLoading = false
            this.loading = false
          })
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/AccumulatedSales/CardComponents/PieDonutCards/Cards.vue